/**
 * Design Color Tokens
 * 
 */

export const colors = {
  // Blue Scale
  blue: {
    1000: '#0088e9',
    900: '#165a8a',
    800: '#165a8acc', // 80% opacity
    100: '#6bc1ff', // ~22% opacity equivalent
    75: '#74c5ff', // ~12% opacity equivalent
  },

  // Surface/Background Scale  
  surface: {
    1000: '#ffffff',
    900: '#f9f9f7',
    800: '#f4f3ef', 
    700: '#efeee8',
    200: '#423E35',
    100: '#0f0f0b',
  },

  // Red Scale
  red: {
    1000: '#e00000',
    900: '#a01313',
    800: '#a01313cc', // 80% opacity
    100: '#ff8a8a', // ~20% opacity equivalent
    75: '#ff8a8a', // ~8% opacity equivalent
  },

  // Amber Scale
  amber: {
    1000: '#ea9400',
    900: '#7a4d00',
    800: '#7a4d00cc', // 80% opacity
    100: '#f3c068', // ~25% opacity equivalent
    75: '#f3c068', // ~15% opacity equivalent
  },

  // Green Scale
  green: {
    1000: '#56db18',
    900: '#2e5e18',
    800: '#2e5e18cc', // 80% opacity
    100: '#8dd56a', // ~24% opacity equivalent
    75: '#8ed16d', // ~12% opacity equivalent
  },

  // Purple Scale
  purple: {
    1000: '#852ee9',
    900: '#5632a4',
    800: '#5632a4cc', // 80% opacity
    100: '#c1aaf2', // ~25% opacity equivalent
    75: '#c1aaf2', // ~10% opacity equivalent
  },

  // Neutral Scale
  neutral: {
    1000: '#1a1a1a',
    900: '#36393d',
    800: '#36393de6', // 90% opacity
    700: '#36393dcc', // 80% opacity
    600: '#36393d99', // 60% opacity
    500: '#36393d73', // 45% opacity
    200: '#36393d40', // 25% opacity
    100: '#36393d14', // 8% opacity
    50: '#36393d0a', // 4% opacity
  },

  contrast:{
    900: "#f2ece9"
  },

  // Brand Colors
  brand: {
    axonianGold: '#fec62e',
    fususGreen: '#67bd4d'
  },

  // Legacy mappings (for compatibility with existing MUI palette)
  white: '#ffffff',
  black: '#000000',
} as const;

export default colors; 